import { highRisedBuilding } from './data/HighRisedBuildingData';

export default {
	buildPermit: 'api/Application/BuildingPermit/',
	designApproval: 'api/Processing/Phase1/AnusuchiKa/',
	anusuchiGa: 'api/Processing/Phase1/AnusuchiGa/',
	anusuchiGha: 'api/Processing/Phase1/AnusuchiGha/',
	architecturalDesignB: 'api/Processing/Phase1/ArchitecturalDesignClassB/',
	architecturalDesignC: 'api/Processing/Phase1/ArchitecturalDesignClassC/',
	architectureDesignerManjuriPatra: 'api/Processing/Phase1/ArchitectureDesignerManjuriPatra/',
	structuralDesignerManjuriPatra: 'api/Processing/Phase1/StructuralDesignerManjuriPatra/',
	aminkoPratibedan: 'api/Processing/AminkoPratibedan/',
	structureDesignB: 'api/Processing/Phase1/StructureDesignB/',
	structureDesignC: 'api/Processing/Phase1/StructureDesignC/',
	electricalDesign: 'api/Processing/Phase1/ElectricalDesign/',
	sanitaryDesign: 'api/Processing/Phase1/SanitaryDesign/',
	mapTechnicalDescription: 'api/processing/phase1/MapTechnicalDescription/',
	mapCheckReport: 'api/Processing/Phase1/MapCheckReport/',
	noticePeriodFor15Days: 'api/Processing/Phase1/NoticePeriodFor15Days/',
	noticePaymentApplication: 'api/Processing/NoticePaymentApplication/',
	surjaminMuchulka: 'api/Processing/SurjaminMuchulka/',
	prabhidikPratibedhanPesh: 'api/Processing/PrabhidikPratibedhanPesh/',
	rajaswaEntry: 'api/Processing/Phase1/RajaswaEntry/',
	rajaswaVoucher: 'api/Processing/RajaswaVoucher/',
	forwardToNext: 'api/Application/Forwarding/Phase1/',
	fileUpload: 'api/Processing/FileStorageApplication/',
	allowancePaper: 'api/Processing/AllowancePaper/',
	gharnakshaSurjaminMuchulka: 'api/Processing/GharnakshaSurjaminMuchulka/',
	gharNaksakoKabuliyatnama: 'api/Processing/GharNaksakoKabuliyatnama/',
	gharCompoundWallNaap: 'api/Processing/GharCompoundwallkoNaap/',
	noteorderPilengthLevel: 'api/Processing/NoteorderPilengthLevel/',
	superStructureBuild: 'api/Processing/SuperStructureBuild/',
	plinthLevelOwnerRepresentation: 'api/Processing/PlinthLevelOwnerRepresentation/',
	SuperStructureNoteOrder: 'api/Processing/SuperStructureNoteOrder/',
	DosrocharanAbedan: 'api/Processing/DosrocharanAbedan/',
	DosrocharanPrabidhikView: 'api/Processing/DosrocharanPrabidhik/',
	plintLevelTechApplication: 'api/Processing/PlinthLevelTechapplication/',
	superStructureConstruction: 'api/Processing/SuperStructureConstruction/',
	dosrocharanSupervisor: 'api/Processing/DosrocharanSupervisor/',
	certificateInstruction: 'api/Processing/CertificateInstruction/',
	samsodhitSupStruPratibedan: 'api/Processing/SamsodhitSuperStructureIjajatPratibedan/',
	sansodhanSuperTippaniAdesh: 'api/Processing/SansodhansuperTippaniAdesh/',
	sansodhanSupStruIjjaat: 'api/Processing/SansodhanSuperStructureIjjaat/',
	sansodhanBibaranPahilo: 'api/Processing/SansodhanBibaranPahilo/',
	sansodhanGariNibedan: 'api/Processing/SansodhanGariNibedan/',
	sansodhanTippani: 'api/Processing/SansodhanTippani/',
	sansodhankoTippaniAdesh: 'api/Processing/SansodhankoTippaniAdesh/',
	superstructurekoTippaniadesh: 'api/Processing/SuperstructurekoTippaniadesh/',
	allcomments: 'api/Processing/Comment/',
	allhistory: 'api/Processing/History/',
	buildingBuild: 'api/Processing/BuildingBuildCertificateView/',
	buildingFinish: 'api/Processing/BuildingFinishCertificateView/',
	pahiloVuktani: 'api/Processing/PahilocharanBillVuktani/',
	dosroVuktani: 'api/Processing/DosrocharanBillVuktani/',
	namsariBillVuktani: 'api/Processing/NamsariBillVuktani/',
	sansodhanVuktani: 'api/Processing/SansodhanBillVuktani/',
	puranoGharTippani: 'api/Processing/PuranoGharNirmanTippani/',
	puranoPramanPatra: 'api/Processing/PuranoSampannaPramanPatra/',
	certificateNote: 'api/Processing/CertificateNote/',
	namsariTippani: 'api/Processing/NamsariTippaniAdes/',
	supernirmaanKarya: 'api/Processing/SuperstructurekoNirmanKarya/',
	waresnama: 'api/Processing/Waresnama/',
	manjurinama: 'api/Processing/Manjurinama/',
	kabuliyatnama: 'api/Processing/Kabuliyatnama/',
	aminKoSthalgatPratibedan: 'api/Processing/AminKoSthalgatPratibedan/',
	noObjectionSheet: 'api/Processing/NoObjectionSheet/',
	tallaThapIjajatPatra: 'api/Processing/TallaThapIjajatPatra/',
	tallaThapIjajatRequest: 'api/Processing/TallaThapIjajatRequest/',
	tallaThapIjajatTippaniades: 'api/Processing/TallaThapIjajatTippaniades/',
	LayoutGariPratibedanIjaja: 'api/Processing/LayoutGariPratibedanIjajat/',
	LayoutGariPratibedanRequest: 'api/Processing/LayoutGariPratibedanRequest/',
	NaksaFilePathayekoBare: 'api/Processing/NaksaFilePathayekoBare/',
	MyadThapRequest: 'api/Processing/MyadThapRequest/',
	MyadThapTippani: 'api/Processing/MyadThapTippani/',
	MyadThapApproval: 'api/Processing/MyadThapApproval/',
	DharautiPhirtaBare: 'api/Processing/DharautiPhirtaBare/',
	DharautiPhirtaTippaniAdes: 'api/Processing/DharautiPhirtaTippaniAdes/',
	NayaNirmanPramanPatraDharautiPhirta: 'api/Processing/NayaNirmanPramanPatraDharautiPhirta/',
	NayaRecordPathayekoNamsari: 'api/Processing/NayaRecordPathayekoNamsari/',
	SansodhitSuperStructureIjajatSambandhama: 'api/Processing/SansodhitSuperStructureIjajatSambandhama/',
	SuperStructureSupervisionReport: 'api/Processing/SuperStructureSupervisionReport/',
	CertificateSupervisionReport: 'api/Processing/CertificateSupervisionReport/',
	EarthquakeSafetyNoObjectionSheet: 'api/Processing/EarthquakeSafetyNoObjectionSheet/',
	LandAreaCalculation: 'api/Processing/LandAreaCalculation/',
	FormToBeFilledByDesigner: 'api/Processing/FormToBeFilledByDesigner/',
	SuchanaTaasGariMuchulka: 'api/Processing/SuchanaTaasGariMuchulka/',
	PrathamCharanKaamGarneAnumati: 'api/Processing/PrathamCharanKaamGarneAnumati/',
	// NirmanSampannaPramanPatraAndDharautiFirta: 'api/Processing/NirmanSampannaPramanPatraAndDharautiFirta/',
	PratibeydanSambandhama: 'api/Processing/PratibeydanSambandhama/',
	PratibeydanPeshGarekoBare: 'api/Processing/PratibeydanPeshGarekoBare/',
	fifteenDaysNotice: 'api/Processing/KaryalayaPrayojan15DaysNotice/',
	SthalgatNiirikshyanGariPesh: 'api/Processing/Phase1/SthalgatNiirikshyanGariPesh/',
	highRisedBuildingapi: 'api/Processing/HighRisedBuildings/',
	forMultiStoreyBuilding: 'api/Processing/MultiStoreyForensic/',

	noObjectionCertificateapi: 'api/Processing/Phase1/NoObjectionCertificate/',
	// Public
	createAccount: 'Utility/UserRequest',

	// Utilities
	organizationUser: 'api/Utility/OrganizationUser/',
	renewDesigner: 'api/Utility/OrganizationUser/Renew/',
	organizationUserInfo: 'api/Utility/OrganizationUser/Info',
	designerRenewStatus: 'api/Utility/OrganizationUser/DesignerRenewStatus',
	userRequest: 'api/Utility/UserRequest',
	organizationMaster: 'api/Utility/OrganizationMaster',
	fiscalYear: 'api/Utility/FiscalYear/',
	fileCategories: 'api/Utility/FileStorageCategory',
	formNameMaster: 'api/Utility/FormNameMaster',
	formGroup: 'api/Utility/FormGroup',
	formGroupMaster: 'api/Utility/FormGroupMaster',
	forwardMaster: 'api/Utility/ApplicationForwardingSetup/',
	anusuchiKaMaster: 'api/Utility/AnusuchiKaMaster/',
	password: 'api/ChangePassword',
	otherSetBack: 'api/Utility/OtherSetBackMaster',
	roadSetBack: 'api/Utility/RoadSetBackMaster',
	riverSetBack: 'api/Utility/RiverSetBackMaster',
	buildingConstructionSetback: '/api/Utility/BuildingConstructionRule',
	highTensionSetBack: 'api/Utility/HighTensionSetBackMaster',
	classGroup: 'api/Utility/ClassGroup',
	hasRevised: 'api/Utility/HasRevised',
	changeDesigner: 'api/Utility/ChangeDesigner',
	masonList: 'api/Utility/MasonList',
	activity: 'api/Application/Activity/',
	apiList: 'api/Application/API/',
	menuMaster: 'api/Utility/MenuMaster/',
	menuAccess: 'api/Utility/MenuUserAccess/',
	rajasowSetup: 'api/Utility/RajashowMaster',
	wardSetup: 'api/Setup/WardMaster',
	userType: '/api/Utility/UserTypeMaster',
	contacts: 'api/application/Contacts',
	naksaPassCertificate: 'api/Processing/NaksaPassCertificate/',
	layoutTathaSarjaminGariFileFirta: 'api/Processing/LayoutTathaSarjaminGariFileFirta/',

	// -- Form Masters
	archiBMaster: 'api/Utility/ArchitecturalDesignBMaster',
	mapCheckMaster: 'api/Utility/MapCheckReportMaster',
	archiCMaster: 'api/Utility/ArchitecturalDesignCMaster',
	elecDesignMaster: 'api/Utility/ElectricalDesignRequirementMaster',

	//Build permits
	tasks: 'api/Application/BuildingPermit/Task/',
	taskFilter: 'api/Application/BuildingPermit/Task',
	permitFilter: 'api/Application/BuildingPermit/Filter?constructionType=&year=&nibedakName=&kittaNo=&wardNo=',
	completedFilter:
		'api/Application/BuildingPermit/Filter?constructionType=&year=&nibedakName=&kittaNo=&wardNo=&applicationStatus=कारबाही पूर्ण भएको',
	applicationFilter: 'api/Application/BuildingPermit/Filter',
	completedPermitList: 'api/Application/BuildingPermit/Completed',
	tallaThapList: 'api/Application/BuildingPermit/Talathap',
	namsariSetup: 'api/BuildingPermitApplication/NameTransafer',
	namsariHistory: 'api/BuildingPermitApplication/NameTransafer/History',
	discardHistory: 'api/Application/BuildingPermit/Discard',
	myadSetup: 'api/Application/BuildingPermit/Expired',
	myadApproveSetup: 'api/Application/BuildingPermit/ExpiredRequest',

	//Dynamic apis
	d_ebpsTables: 'api/Dynamic/EbpsTables',
	// api/Dynamic/EbpsTables/Columns/{id} --> delete mapping for ebps columns
	d_ebpsTablesColumns: 'api/Dynamic/EbpsTables/Columns',
	// api/Dynamic/EbpsTables/sync?tableId=id
	d_ebpsTablesSync: 'api/Dynamic/EbpsTables/sync',
	d_formNameMaster: 'api/Dynamic/FormNameMaster',
	// api/Dynamic/FormNameMaster/Fields/{id} --> delete mapping for form fields
	d_formNameMasterFields: 'api/Dynamic/FormNameMaster/Fields',
	d_formNameMasterFormPermissions: 'api/Dynamic/FormNameMaster/FormPermissions',
	d_general: 'api/Dynamic/General/',
	d_vocabulary: 'api/Dynamic/Vocabulary',
	d_vocabularyDetails: 'api/Dynamic/Vocabulary/Details',
};
